<div class="info-container">
  <div class="background">
    <img src="#" [lazyLoad]="truckImage" [defaultImage]="truckImage" errorImage="./assets/ui/shared/images/not_found_error_page.png" class="image" />
    <svg viewBox="0 0 200 20" class="tilt">
      <path d="M 0,12 200,0 v 20 H 0 Z" class="path"></path>
    </svg>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
<div class="extension"></div>
